import * as React from "react";
import { graphql } from "gatsby";
import PrevNext from "../components/prevNext";
import Seo from "../components/seo";
import Layout from "../components/layout";
import * as styles from "./singleBlog.module.css";

const SingleBlog = (props) => {
  const { markdownRemark } = props.data;
  const { frontmatter, html } = markdownRemark;

  return (
    <Layout pageTitle={null}>
      <div className={styles.editor}>
        <h1 className={styles.title}>{frontmatter.title}</h1>
        <p className={styles.date}>{frontmatter.date}</p>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      <nav>
        <PrevNext pageContext={props.pageContext} />
      </nav>
    </Layout>
  );
};

export default SingleBlog;

export const query = graphql`
  query SingleBlogQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        date
        title
        description
        image
      }
      fields {
        slug
      }
      html
    }
  }
`;

export const Head = ({ data }) => {
  const { frontmatter, fields } = data.markdownRemark;

  return (
    <Seo
      title={frontmatter.title}
      description={frontmatter.description}
      image={frontmatter.image}
      slug={fields.slug} // ← 追加
    />
  );
};
